module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-settings/147assets/fonts/f4769f9bdb7466be65088239c12046d1.eot";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.eot
// module id = 259
// module chunks = 4